// /* eslint-disable no-unused-vars */
// import React, { useEffect, useState } from "react";
// import { useDispatch, useSelector } from "react-redux";
// import { useNavigate } from "react-router-dom";
// import { fetchLoanReports, deleteLoan } from "../redux/slices/loanReportSlice";
// import { ToastContainer, toast } from "react-toastify";
// import "react-toastify/dist/ReactToastify.css";
// import "../css/LoanReport.css";
// import axios from "axios";

// const ITEMS_PER_PAGE_OPTIONS = [10, 25, 50];

// const API_URL = "https://payyug.in/api/"; // replace with your API base

// const LoanReportTest = () => {
//   const dispatch = useDispatch();
//   const navigate = useNavigate();

//   const { loans, loading, error } = useSelector((state) => state.loanReport);

//   const [filterData, setFilterData] = useState({
//     fromDate: "",
//     toDate: "",
//     loanAccountNumber: "",
//     userId: "",
//     userName: "",
//     loanStatus: "",
//   });

//   const [filteredLoans, setFilteredLoans] = useState([]);
//   const [showConfirmDialog, setShowConfirmDialog] = useState(false);

//   const [currentPage, setCurrentPage] = useState(1);
//   const [itemsPerPage, setItemsPerPage] = useState(10);

//   useEffect(() => {
//     dispatch(fetchLoanReports());
//   }, [dispatch]);

//   useEffect(() => {
//     setFilteredLoans(loans);
//     setCurrentPage(1);
//   }, [loans]);

//   useEffect(() => {
//     if (error) {
//       toast.error(`Error: ${error}`);
//     }
//   }, [error]);

//   const handleChange = (e) => {
//     setFilterData({ ...filterData, [e.target.name]: e.target.value });
//   };

//   const handleSubmit = (e) => {
//     e.preventDefault();
//     const filtered = loans.filter((loan) => {
//       const {
//         fromDate,
//         toDate,
//         loanAccountNumber,
//         userId,
//         userName,
//         loanStatus,
//       } = filterData;
//       const appliedDate = new Date(loan.appliedDate);

//       return (
//         (!fromDate || appliedDate >= new Date(fromDate)) &&
//         (!toDate || appliedDate <= new Date(toDate)) &&
//         (!loanAccountNumber ||
//           loan.loanAccountNumber
//             ?.toLowerCase()
//             .includes(loanAccountNumber.toLowerCase())) &&
//         (!userId || loan.userId?.toString() === userId) &&
//         (!userName ||
//           loan.userName?.toLowerCase().includes(userName.toLowerCase())) &&
//         (!loanStatus || loan.status?.toLowerCase() === loanStatus.toLowerCase())
//       );
//     });

//     setFilteredLoans(filtered);
//     setCurrentPage(1);
//   };

//   const handleApproveLoan = async (loan) => {
//     console.log("➡️ Approve Loan button clicked");
//     console.log("Loan ID:", loan.id);
//     console.log("Current Loan Status:", loan.status);

//     if (loan.status === "Approved" || loan.status === "disbursed") {
//       console.info(`⚠️ Loan is already ${loan.status}, skipping approval.`);
//       toast.info(`Loan is already ${loan.status}`);
//       return;
//     }

//     try {
//       console.log("🔧 Sending approve loan API request...");
//       const response = await axios.post(
//         `${API_URL}approveLoan-personal/${loan.id}/approve`,
//         { approvalRemark: "Verified documents" }
//       );

//       console.log("✅ API Response:", response.data);
//       toast.success(response.data.message);

//       dispatch(fetchLoanReports());
//     } catch (error) {
//       console.error("🚨 Loan Approval Error:", error);
//       toast.error(error.response?.data?.message || "Failed to approve loan");
//     }
//   };

//   const handleItemsPerPageChange = (e) => {
//     setItemsPerPage(Number(e.target.value));
//     setCurrentPage(1);
//   };

//   const formatDate = (dateStr) => {
//     if (!dateStr) return "N/A";
//     const date = new Date(dateStr);
//     return `${date.getFullYear()}-${String(date.getMonth() + 1).padStart(
//       2,
//       "0"
//     )}-${String(date.getDate()).padStart(2, "0")} ${String(
//       date.getHours()
//     ).padStart(2, "0")}:${String(date.getMinutes()).padStart(2, "0")}`;
//   };

//   const totalPages = Math.ceil(filteredLoans.length / itemsPerPage);
//   const startIndex = (currentPage - 1) * itemsPerPage;
//   const currentLoans = filteredLoans.slice(
//     startIndex,
//     startIndex + itemsPerPage
//   );

//   return (
//     <div className="LoanReport-container">
//       {/* Filter Section */}
//       <section className="LoanReport-filterSection">
//         <h2 className="LoanReport-title">Loan Report Filter</h2>
//         <p className="LoanReport-subtitle">
//           Use filter to see more precise report
//         </p>
//         <form className="LoanReport-form" onSubmit={handleSubmit}>
//           <div className="LoanReport-grid">
//             <div className="LoanReport-formGroup">
//               <label>From Date</label>
//               <input type="date" name="fromDate" onChange={handleChange} />
//             </div>
//             <div className="LoanReport-formGroup">
//               <label>To Date</label>
//               <input type="date" name="toDate" onChange={handleChange} />
//             </div>
//             <div className="LoanReport-formGroup">
//               <label>Loan Account Number</label>
//               <input
//                 type="text"
//                 name="loanAccountNumber"
//                 placeholder="Loan account number"
//                 onChange={handleChange}
//               />
//             </div>
//             <div className="LoanReport-formGroup">
//               <label>Applicant User ID</label>
//               <input
//                 type="text"
//                 name="userId"
//                 placeholder="Applicant user id"
//                 onChange={handleChange}
//               />
//             </div>
//             <div className="LoanReport-formGroup">
//               <label>Applicant User Name</label>
//               <input
//                 type="text"
//                 name="userName"
//                 placeholder="Applicant user name"
//                 onChange={handleChange}
//               />
//             </div>
//             <div className="LoanReport-formGroup">
//               <label>Choose Loan Status</label>
//               <select name="loanStatus" onChange={handleChange}>
//                 <option value="">Select loan status</option>
//                 <option value="Pending">Pending</option>
//                 <option value="Approved">Approved</option>
//                 <option value="Rejected">Rejected</option>
//                 <option value="Closed">Closed</option>
//               </select>
//             </div>
//           </div>
//           <button type="submit" className="LoanReport-submitBtn">
//             Submit
//           </button>
//         </form>
//       </section>

//       {/* Loan Details Section */}
//       <section className="LoanReport-detailsSection">
//         <div className="LoanReport-tableHeader">
//           <div>
//             <label>Show </label>
//             <select onChange={handleItemsPerPageChange} value={itemsPerPage}>
//               {ITEMS_PER_PAGE_OPTIONS.map((count) => (
//                 <option key={count} value={count}>
//                   {count}
//                 </option>
//               ))}
//             </select>
//             <span> entries</span>
//           </div>
//           <input
//             type="text"
//             placeholder="Search..."
//             className="LoanReport-searchInput"
//           />
//         </div>

//         <div className="LoanReport-tableContainer">
//           <table className="LoanReport-table">
//             <thead>
//               <tr>
//                 <th>SN</th>
//                 <th>Loan ID</th>
//                 <th>Borrower Name</th>
//                 <th>Loan Amount</th>
//                 <th>Interest Amount</th>
//                 <th>Loan Tenure</th>
//                 <th>Loan Frequency</th>
//                 <th>Applied Date</th>
//                 <th>Approval Date</th>
//                 <th>Disbursal Date</th>
//                 <th>Loan Status</th>
//                 <th>EMI Amount</th>
//                 <th>Total Payable</th>
//                 <th>Loan Type</th>
//                 <th>View EMI</th>
//                 <th>Loan Card</th>
//                 <th>Loan Status</th>
//                 <th>Approved Action</th>
//                 <th>Disbursement Action</th>
//               </tr>
//             </thead>
//             <tbody>
//               {loading ? (
//                 <tr>
//                   <td colSpan="22">Loading...</td>
//                 </tr>
//               ) : error ? (
//                 <tr>
//                   <td colSpan="22">Error: {error}</td>
//                 </tr>
//               ) : currentLoans.length === 0 ? (
//                 <tr>
//                   <td colSpan="22">No data available</td>
//                 </tr>
//               ) : (
//                 currentLoans.map((loan, index) => (
//                   <tr key={loan.id}>
//                     <td>{startIndex + index + 1}</td>
//                     <td>{loan.loanAccountNumber || "N/A"}</td>
//                     <td>{loan.userName || "N/A"}</td>
//                     <td>{loan.loanAmount || "N/A"}</td>
//                     <td>{loan.loanInterest || "N/A"}</td>
//                     <td>{loan.loanTenure || "N/A"}</td>
//                     <td>{loan.loanRecoveryFrequency || "N/A"}</td>
//                     <td>{formatDate(loan.loanAppliedDate)}</td>
//                     <td>{formatDate(loan.firstEmiDate)}</td>
//                     <td>{formatDate(loan.disbursalDate)}</td>
//                     <td>{loan.status || "N/A"}</td>
//                     <td>{loan.loanEmiAmount || "N/A"}</td>
//                     <td>{loan.loanPayable || "N/A"}</td>
//                     <td>{loan.loanType || "N/A"}</td>
//                     <td>
//                       <button
//                         onClick={() => navigate(`/ViewEmiLoanData/${loan.id}`)}
//                       >
//                         View EMI
//                       </button>
//                     </td>
//                     <td>
//                       <button
//                         onClick={() => navigate(`/LoanCardPage/${loan.id}`)}
//                       >
//                         Loan Card
//                       </button>
//                     </td>
//                     <td>{loan.status || "N/A"}</td>

//                     {/* Approved Action */}
//                     <td>
//                       {loan.status === "PENDING" && (
//                         <button
//                           onClick={() => {
//                             const confirmApprove = window.confirm(
//                               "Do you want to approve this loan?"
//                             );
//                             if (confirmApprove) handleApproveLoan(loan);
//                           }}
//                         >
//                           Approve Loan
//                         </button>
//                       )}
//                       {(loan.status === "Approved" || loan.status === "disbursed") && (
//                         <span style={{ color: "green", fontWeight: "bold" }}>✔</span>
//                       )}
//                     </td>

//                     {/* Disbursement Action */}
//                     <td>
//                       {loan.status === "Approved" && (
//                         <button
//                           onClick={() =>
//                             navigate(`/LoanDisbursement/${loan.id}`, {
//                               state: { selectedLoan: loan },
//                             })
//                           }
//                           style={{
//                             marginLeft: "6px",
//                             background: "#1f8b94ff",
//                             color: "#fff",
//                             padding: "5px 10px",
//                             border: "none",
//                             borderRadius: "4px",
//                           }}
//                         >
//                           Disburse Loan
//                         </button>
//                       )}
//                       {loan.status === "disbursed" && (
//                         <span style={{ color: "green", fontWeight: "bold" }}>✔</span>
//                       )}
//                     </td>
//                   </tr>
//                 ))
//               )}
//             </tbody>
//           </table>
//         </div>

//         {/* Pagination Controls */}
//         {totalPages > 1 && (
//           <div className="LoanReport-pagination">
//             <button
//               disabled={currentPage === 1}
//               onClick={() => setCurrentPage((prev) => prev - 1)}
//             >
//               Previous
//             </button>
//             <span>
//               Page {currentPage} of {totalPages}
//             </span>
//             <button
//               disabled={currentPage === totalPages}
//               onClick={() => setCurrentPage((prev) => prev + 1)}
//             >
//               Next
//             </button>
//           </div>
//         )}
//       </section>

//       <ToastContainer position="top-right" autoClose={3000} />
//     </div>
//   );
// };

// export default LoanReportTest;

// /* eslint-disable no-unused-vars */
// import React, { useEffect, useState } from "react";
// import { useNavigate } from "react-router-dom";
// import axios from "axios";
// import { ToastContainer, toast } from "react-toastify";
// import "react-toastify/dist/ReactToastify.css";
// import "./LoanReportTest.css";

// const ITEMS_PER_PAGE_OPTIONS = [10, 25, 50];
// const API_URL = "https://payyug.in/api";

// const LoanReportTest = () => {
//   const navigate = useNavigate();

//   const [centers, setCenters] = useState([]);
//   const [selectedCenter, setSelectedCenter] = useState(null);
//   const [groups, setGroups] = useState([]);
//   const [selectedGroup, setSelectedGroup] = useState(null);
//   const [branchs, setBranchs] = useState([]);
//   const [selectedBranch, setSelectedBranch] = useState(null);

//   const [loans, setLoans] = useState([]);
//   const [filteredLoans, setFilteredLoans] = useState([]);

//   const [currentPage, setCurrentPage] = useState(1);
//   const [rowsPerPage, setRowsPerPage] = useState(10);
//   const [totalPages, setTotalPages] = useState(1);

//   const [loading, setLoading] = useState(false);
//   const [error, setError] = useState(null);

//   /* ================= FETCH Branch ================= */
//   useEffect(() => {
//     const fetchBranch = async () => {
//       try {
//         const res = await axios.get(`${API_URL}/get-branch`, {
//           params: {
//             SuperAdminId: localStorage.getItem("adminuserId"),
//             limit: "all",
//           },
//         });
//         // console.log("branch data", res.data);
//         setBranchs(res?.data.branches);
//       } catch (err) {
//         console.error(err);
//       }
//     };

//     fetchBranch();
//   }, []);

//   // console.log("slected branch",selectedBranch?.id)
//   /* ================= FETCH CENTERS ================= */
//   useEffect(() => {
//     if (!selectedBranch?.id) return;
//     const fetchCenters = async () => {
//       try {
//         const superAdminId = localStorage.getItem("adminuserId");
//         if (!superAdminId) return;

//         const res = await axios.get(`${API_URL}/group/centre`, {
//           params: {
//             superAdminId,
//             branchid: selectedBranch?.id,
//           },
//         });

//         // console.log("center list", res.data?.data);

//         setCenters(res.data?.data || []);
//       } catch (err) {
//         console.error(err);
//       }
//     };
//     fetchCenters();
//   }, [selectedBranch]);

//   /* ================= FETCH GROUPS ================= */
//   useEffect(() => {
//     if (!selectedBranch?.id) return;
//     if (!selectedCenter?.id) return;

//     const fetchGroups = async () => {
//       try {
//         const superAdminId = localStorage.getItem("adminuserId");

//         const res = await axios.get(`${API_URL}/groupupdate/getall`, {
//           params: {
//             superAdminId,
//             CenterId: selectedCenter.id,
//           },
//         });
//         setGroups(res.data?.data || []);
//       } catch (err) {
//         console.error(err);
//       }
//     };

//     fetchGroups();
//   }, [selectedCenter, selectedBranch]);

//   /* ================= FETCH LOANS ================= */
//   const fetchLoans = async (page = currentPage, limit = rowsPerPage) => {
//     try {
//       setLoading(true);
//       setError(null);

//       const token = localStorage.getItem("authToken");
//       const superAdminId = localStorage.getItem("adminuserId");

//       const res = await axios.get(`${API_URL}/group-loan/group/list`, {
//         params: {
//           superAdminId,
//           page,
//           limit,
//         },
//         headers: { Authorization: `Bearer ${token}` },
//       });

//       console.log(res.data);
//       setLoans(res.data?.data || []);
//       // setFilteredLoans(res.data?.data || []);
//       setTotalPages(res.data?.totalPages || 1);
//     } catch (err) {
//       setError("Failed to fetch loans");
//     } finally {
//       setLoading(false);
//     }
//   };

//   useEffect(() => {
//     fetchLoans(currentPage, rowsPerPage);
//   }, [currentPage, rowsPerPage]);

//   /* ================= FILTER ================= */
//   const handleSubmit = (e) => {
//     e.preventDefault();
//      if (!selectedBranch || !selectedCenter || !selectedGroup) {
//         toast.error("Please select Branch, Center, and Group before filtering.");
//         return;
//       }

//     const filtered = loans.filter((loan) => {
//       const centerMatch =
//         !selectedCenter || loan.centerId === selectedCenter.id;
//       const groupMatch = !selectedGroup || loan.groupId === selectedGroup.id;
//       const branchMatch =
//         !selectedBranch || loan.branchId === selectedBranch.id;
//       return centerMatch && groupMatch && branchMatch;
//     });

//     setFilteredLoans(filtered);
//     // setCurrentPage(1);
//   };

//   const handleItemsPerPageChange = (e) => {
//     setRowsPerPage(Number(e.target.value));
//     setCurrentPage(1);
//   };

//   const formatDate = (dateStr) => {
//     if (!dateStr) return "N/A";
//     const date = new Date(dateStr);
//     return `${date.getFullYear()}-${String(date.getMonth() + 1).padStart(
//       2,
//       "0"
//     )}-${String(date.getDate()).padStart(2, "0")} ${String(
//       date.getHours()
//     ).padStart(2, "0")}:${String(date.getMinutes()).padStart(2, "0")}`;
//   };

//   return (
//     <div className="loan-report-container">
//       {/* Filter Section */}
//       <section className="loan-report-filter-section">
//         <h2 className="loan-report-title">Loan Report Filter</h2>
//         <p className="loan-report-subtitle">
//           Use filter to see more precise report
//         </p>
//         <form className="loan-report-form" onSubmit={handleSubmit}>
//           <div className="loan-report-grid">
//             {/* Branch */}
//             <div className="loan-report-form-group">
//               <label>Select Branch</label>
//               <select
//                 value={selectedBranch?.id || ""}
//                 onChange={(e) => {
//                   const branch = branchs.find(
//                     (br) => br.id === Number(e.target.value)
//                   );
//                   setSelectedBranch(branch);
//                   setSelectedCenter(null); // reset
//                   setSelectedGroup(null); // reset
//                 }}
//               >
//                 <option value="">Select Branch</option>
//                 {branchs.map((b) => (
//                   <option key={b.id} value={b.id}>
//                     {b.name}
//                   </option>
//                 ))}
//               </select>
//             </div>

//             {/* Center */}
//             <div className="loan-report-form-group">
//               <label>Select Center</label>
//               <select
//                 value={selectedCenter?.id || ""}
//                 disabled={!selectedBranch}
//                 onChange={(e) => {
//                   const center = centers.find(
//                     (cn) => cn.id === Number(e.target.value)
//                   );
//                   setSelectedCenter(center);
//                   setSelectedGroup(null); // reset
//                 }}
//               >
//                 <option value="">Select Center</option>
//                 {centers.map((c) => (
//                   <option key={c.id} value={c.id}>
//                     {c.CenterName}
//                   </option>
//                 ))}
//               </select>
//             </div>

//             {/* Group */}
//             <div className="loan-report-form-group">
//               <label>Select Group</label>
//               <select
//                 value={selectedGroup?.id || ""}
//                 disabled={!selectedBranch || !selectedCenter}
//                 onChange={(e) => {
//                   const group = groups.find(
//                     (gr) => gr.id === Number(e.target.value)
//                   );
//                   setSelectedGroup(group);
//                 }}
//               >
//                 <option value="">Select Group</option>
//                 {groups.map((g) => (
//                   <option key={g.id} value={g.id}>
//                     {g.groupname}
//                   </option>
//                 ))}
//               </select>
//             </div>
//           </div>

//           <button type="submit" className="loan-report-submit-btn">
//             Filter
//           </button>
//         </form>
//       </section>

//       {/* Loan Details Section */}
//       <section className="loan-report-details-section">
//         <div className="loan-report-table-header">
//           <div>
//             <label>Show </label>
//             <select onChange={handleItemsPerPageChange} value={rowsPerPage}>
//               {ITEMS_PER_PAGE_OPTIONS.map((count) => (
//                 <option key={count} value={count}>
//                   {count}
//                 </option>
//               ))}
//             </select>
//             <span> entries</span>
//           </div>
//           {/* <input
//             type="text"
//             placeholder="Search..."
//             className="loan-report-search-input"
//           /> */}
//         </div>

//         <div className="loan-report-table-container">
//           <table className="loan-report-table">
//             <thead>
//               <tr>
//                 <th>SN</th>
//                 <th>Loan ID</th>
//                 <th>Borrower Name</th>
//                 <th>Loan Amount</th>
//                 <th>Interest Amount</th>
//                 <th>Loan Tenure</th>
//                 <th>Loan Frequency</th>
//                 <th>Applied Date</th>
//                 <th>Approval Date</th>
//                 <th>Disbursal Date</th>
//                 <th>Loan Status</th>
//                 <th>EMI Amount</th>
//                 <th>Total Payable</th>
//                 <th>Loan Type</th>
//                 {/* <th>View EMI</th>
//                 <th>Loan Card</th> */}
//                 <th>Loan Status</th>
//                 <th>Approved Action</th>
//                 <th>Disbursement Action</th>
//               </tr>
//             </thead>
//             <tbody>
//               {loading ? (
//                 <tr>
//                   <td colSpan="22">Loading...</td>
//                 </tr>
//               ) : error ? (
//                 <tr>
//                   <td colSpan="22">Error: {error}</td>
//                 </tr>
//               ) : filteredLoans.length === 0 ? (
//                 <tr>
//                   <td colSpan="22">No data available</td>
//                 </tr>
//               ) : (
//                 filteredLoans.map((loan, index) => (
//                   <tr key={loan.id}
//                    style={{
//                       backgroundColor:
//                         loan.status?.toLowerCase() === "closed" ? "#f8d7da" : "transparent",
//                     }}>
//                     <td>{(currentPage - 1) * rowsPerPage + index + 1}</td>
//                     <td>{loan.loanAccountNumber || "N/A"}</td>
//                     <td>{loan.memberName || "N/A"}</td>
//                     <td>{loan.loanAmount || "N/A"}</td>
//                     <td>{loan.loanInterest || "N/A"}</td>
//                     <td>{loan.loanTenure || "N/A"}</td>
//                     <td>{loan.loanRecoveryFrequency || "N/A"}</td>
//                     <td>{new Date(loan.loanAppliedDate).toLocaleDateString("en-GB")}</td>
//                     <td>{new Date(loan.approvalDate).toLocaleDateString("en-GB")}</td>
//                     <td>{new Date(loan.disbursalDate).toLocaleDateString("en-GB")}</td>
//                     <td>{loan.status || "N/A"}</td>
//                     <td>{loan.loanEmiAmount || "N/A"}</td>
//                     <td>{loan.loanPayable || "N/A"}</td>
//                     <td>{loan.loanType || "N/A"}</td>
//                     {/* <td>
//                       <button
//                         onClick={() => navigate(`/GroupLoanReport/ViewLoanEmi`)}
//                       >
//                         View EMI
//                       </button>
//                     </td>
//                     <td>
//                       <button
//                         onClick={() => navigate(`/GroupLoanReport/LoanCard`)}
//                       >
//                         Loan Card
//                       </button>
//                     </td> */}
//                     <td>{loan.status || "N/A"}</td>

//                     {/* Approved Action */}
//                     <td>
//                       {loan.status === "pending" && (
//                         <span style={{ color: "red", fontWeight: "bold" }}>
//                           ❌
//                         </span>
//                       )}
//                       {(loan.status === "approved" ||
//                         loan.status === "ACTIVE") && (
//                         <span style={{ color: "green", fontWeight: "bold" }}>
//                           ✔
//                         </span>
//                       )}
//                     </td>

//                     {/* Disbursement Action */}
//                     <td>
//                       {(loan.status === "approved" ||
//                         loan.status === "pending") && (
//                         <span style={{ color: "red", fontWeight: "bold" }}>
//                           ❌
//                         </span>
//                       )}
//                       {loan.status === "ACTIVE" && (
//                         <span style={{ color: "green", fontWeight: "bold" }}>
//                           ✔
//                         </span>
//                       )}
//                     </td>
//                   </tr>
//                 ))
//               )}
//             </tbody>
//           </table>
//         </div>
//       </section>

//       {/* Pagination Controls */}
//       {totalPages > 1 && (
//         <div className="loan-report-pagination">
//           <button
//             onClick={() => setCurrentPage(currentPage - 1)}
//             disabled={currentPage === 1}
//           >
//             ⬅ Prev
//           </button>
//           <span>
//             Page {currentPage} of {totalPages}
//           </span>
//           <button
//             onClick={() => setCurrentPage(currentPage + 1)}
//             disabled={currentPage === totalPages}
//           >
//             Next ➡
//           </button>
//         </div>
//       )}

//       <ToastContainer position="top-right" autoClose={3000} />
//     </div>
//   );
// };

// export default LoanReportTest;

/* eslint-disable no-unused-vars */
import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import "./LoanReportTest.css";

const ITEMS_PER_PAGE_OPTIONS = [50, 100, 200];
const API_URL = "https://payyug.in/api";

const LoanReportTest = () => {
  const navigate = useNavigate();

  const [centers, setCenters] = useState([]);
  const [selectedCenter, setSelectedCenter] = useState(null);
  const [groups, setGroups] = useState([]);
  const [selectedGroup, setSelectedGroup] = useState(null);
  const [branchs, setBranchs] = useState([]);
  const [selectedBranch, setSelectedBranch] = useState(null);
  const [loanType, setLoanType] = useState("");

  const [loans, setLoans] = useState([]);

  const [currentPage, setCurrentPage] = useState(1);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [totalPages, setTotalPages] = useState(1);

  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  /* ================= FETCH Branch ================= */
  useEffect(() => {
    const fetchBranch = async () => {
      try {
        const res = await axios.get(`${API_URL}/get-branch`, {
          params: {
            SuperAdminId: localStorage.getItem("adminuserId"),
            limit: "10000",
          },
        });
        setBranchs(res?.data.branches || []);
      } catch (err) {
        console.error(err);
      }
    };

    fetchBranch();
  }, []);

  /* ================= FETCH CENTERS ================= */
  useEffect(() => {
    if (!selectedBranch?.id) return;

    const fetchCenters = async () => {
      try {
        const superAdminId = localStorage.getItem("adminuserId");
        if (!superAdminId) return;

        const res = await axios.get(`${API_URL}/group/centre`, {
          params: {
            superAdminId,
            branchid: selectedBranch.id,
            limit: "10000",
          },
        });

        setCenters(res.data?.data || []);
      } catch (err) {
        console.error(err);
      }
    };

    fetchCenters();
  }, [selectedBranch]);

  /* ================= FETCH GROUPS ================= */
  useEffect(() => {
    if (!selectedCenter?.id) return;

    const fetchGroups = async () => {
      try {
        const superAdminId = localStorage.getItem("adminuserId");

        const res = await axios.get(`${API_URL}/groupupdate/getall`, {
          params: {
            superAdminId,
            CenterId: selectedCenter.id,
          },
        });

        setGroups(res.data?.data || []);
      } catch (err) {
        console.error(err);
      }
    };

    fetchGroups();
  }, [selectedCenter]);

  /* ================= FETCH LOANS ================= */
  const fetchLoans = async (page = 1, limit = rowsPerPage) => {
    try {
      setLoading(true);
      setError(null);

      const token = localStorage.getItem("authToken");
      const superAdminId = localStorage.getItem("adminuserId");

      const res = await axios.get(`${API_URL}/group-loan/group/list`, {
        params: {
          superAdminId,
          branchId: selectedBranch?.id,
          centerId: selectedCenter?.id,
          groupId: selectedGroup?.id,
          loanType: loanType === "ALL" ? undefined : loanType,
          page,
          limit: "10000",
        },
        headers: { Authorization: `Bearer ${token}` },
      });

      setLoans(res.data?.data || []);
      setTotalPages(res.data?.totalPages || 1);
      setCurrentPage(res.data?.currentPage || 1);
    } catch (err) {
      setError("Failed to fetch loans");
    } finally {
      setLoading(false);
    }
  };

  /* DELETE BUTTON */
const handleDelete = async (id) => {
  const confirmDelete = window.confirm(
    "Are you sure you want to delete this record?"
  );

  if (!confirmDelete) return;

  try {
    const token = localStorage.getItem("authToken");

    await axios.delete(
      `${API_URL}/group-loan/member/delete/${id}`,
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );

    toast.success("Record deleted successfully");

    setLoans((prev) => prev.filter((loan) => loan.id !== id));

  } catch (err) {
    console.error(err);
    toast.error("Failed to delete record");
  }
};

  /* ================= FILTER ================= */
  const handleSubmit = (e) => {
    e.preventDefault();

    if (!selectedBranch || !selectedCenter || !selectedGroup) {
      toast.error("Please select Branch, Center, and Group before filtering.");
      return;
    }

    setCurrentPage(1);
    fetchLoans(1, rowsPerPage);
  };

  /* ================= ITEMS PER PAGE ================= */
  const handleItemsPerPageChange = (e) => {
    const newLimit = Number(e.target.value);
    setRowsPerPage(newLimit);
    setCurrentPage(1);

    if (selectedBranch && selectedCenter && selectedGroup) {
      fetchLoans(1, newLimit);
    }
  };

  const formatDate = (dateStr) => {
    if (!dateStr) return "N/A";
    return new Date(dateStr).toLocaleDateString("en-GB");
  };
const filteredLoans =
  loanType === "" || loanType === "ALL"
    ? loans
    : loans.filter((loan) =>
        (loan.loanType || "")
          .toLowerCase()
          .startsWith(loanType.toLowerCase())  // "fixed" matches "Fixed Loan"
      );

  return (
    <div className="loan-report-container">
      <section className="loan-report-filter-section">
        {/* <h2 className="loan-report-title">Loan Report Filter</h2>
        <p className="loan-report-subtitle">
          Use filter to see more precise report
        </p> */}

        <form className="loan-report-form" onSubmit={handleSubmit}>
          <div className="loan-report-grid">
            {/* Branch */}
            <div className="loan-report-form-group">
              <label>Select Branch</label>
              <select
                value={selectedBranch?.id || ""}
                onChange={(e) => {
                  const branch = branchs.find(
                    (br) => br.id === Number(e.target.value),
                  );
                  setSelectedBranch(branch);
                  setSelectedCenter(null);
                  setSelectedGroup(null);
                  setLoans([]);
                }}
              >
                <option value="">Select Branch</option>
                {branchs.map((b) => (
                  <option key={b.id} value={b.id}>
                    {b.name}
                  </option>
                ))}
              </select>
            </div>

            {/* Center */}
            <div className="loan-report-form-group">
              <label>Select Center</label>
              <select
                value={selectedCenter?.id || ""}
                disabled={!selectedBranch}
                onChange={(e) => {
                  const center = centers.find(
                    (cn) => cn.id === Number(e.target.value),
                  );
                  setSelectedCenter(center);
                  setSelectedGroup(null);
                  setLoans([]);
                }}
              >
                <option value="">Select Center</option>
                {centers.map((c) => (
                  <option key={c.id} value={c.id}>
                    {c.CenterName}
                  </option>
                ))}
              </select>
            </div>

            {/* Group */}
            <div className="loan-report-form-group">
              <label>Select Group</label>
              <select
                value={selectedGroup?.id || ""}
                disabled={!selectedCenter}
                onChange={(e) => {
                  const group = groups.find(
                    (gr) => gr.id === Number(e.target.value),
                  );
                  setSelectedGroup(group);
                  setLoans([]);
                }}
              >
                <option value="">Select Group</option>
                {groups.map((g) => (
                  <option key={g.id} value={g.id}>
                    {g.groupname}
                  </option>
                ))}
              </select>
            </div>
            {/* Loan Type */}
            <div className="loan-report-form-group">
              <label>Loan Type</label>
              <select
                value={loanType}
                onChange={(e) => {
                  setLoanType(e.target.value);
                }}
              >
                <option value="ALL">All</option>
                <option value="Fixed Loan">Fixed</option>
                <option value="Individual Loan">Individual</option>
              </select>
            </div>
          </div>

          <button type="submit" className="loan-report-submit-btn">
            Filter
          </button>
        </form>
      </section>

      {/* ================= TABLE ================= */}
      <section className="loan-report-details-section">
        <div className="loan-report-table-header">
          <div>
            <label>Show </label>
            <select onChange={handleItemsPerPageChange} value={rowsPerPage}>
              {ITEMS_PER_PAGE_OPTIONS.map((count) => (
                <option key={count} value={count}>
                  {count}
                </option>
              ))}
            </select>
            <span> entries</span>
          </div>
        </div>

        <div className="loan-report-table-container">
          <table className="loan-report-table">
            <thead>
              <tr>
                <th>SN</th>
                <th>Loan ID</th>
                <th>Borrower Name</th>
                <th>Loan Amount</th>
                <th>Interest Amount</th>
                <th>Loan Tenure</th>
                <th>Loan Frequency</th>
                <th>Applied Date</th>
                <th>Approval Date</th>
                <th>First Emi Date</th>
                <th>Loan Status</th>
                <th>EMI Amount</th>
                <th>Total Payable</th>
                <th>Loan Type</th>
                <th>Approved</th>
                <th>Disbursed</th>
                <th>Action</th>
              </tr>
            </thead>

            <tbody>
              {loading ? (
                <tr>
                  <td colSpan="17">Loading...</td>
                </tr>
              ) : error ? (
                <tr>
                  <td colSpan="17">{error}</td>
                </tr>
              ) : filteredLoans.length === 0 ? (
                <tr>
                  <td colSpan="17">No data available</td>
                </tr>
              ) : (
                filteredLoans.map((loan, index) => {
                  const status = loan.status?.toLowerCase();

                  return (
                    <tr key={loan.id}>
                      <td>{(currentPage - 1) * rowsPerPage + index + 1}</td>
                      <td>{loan.loanAccountNumber || "N/A"}</td>
                      <td>{loan.memberName || "N/A"}</td>
                      <td>{loan.loanAmount || "N/A"}</td>
                      <td>{loan.loanInterest || "N/A"}</td>
                      <td>{loan.loanTenure || "N/A"}</td>
                      <td>{loan.loanRecoveryFrequency || "N/A"}</td>
                      <td>
                        {new Date(loan.loanAppliedDate).toLocaleDateString(
                          "en-GB",
                        ) || "N/A"}
                      </td>
                      <td>
                        {new Date(loan.approvalDate).toLocaleDateString(
                          "en-GB",
                        ) || "N/A"}
                      </td>
                      <td>
                        {new Date(loan.disbursalDate).toLocaleDateString(
                          "en-GB",
                        ) || "N/A"}
                      </td>
                      <td>{loan.status || "N/A"}</td>
                      <td>{loan.loanEmiAmount || "N/A"}</td>
                      <td>{loan.loanPayable || "N/A"}</td>
                      <td>{loan.loanType || "N/A"}</td>

                      <td>
                        {status === "approved" || status === "active" ? (
                          <span style={{ color: "green",fontWeight: "700" }}>✔</span>
                        ) : (
                          <span style={{ color: "red", fontWeight: "700" }}>
                            X
                          </span>
                        )}
                      </td>

                      <td>
                        {status === "active" ? (
                          <span style={{ color: "green",fontWeight: "700" }}>✔</span>
                        ) : (
                          <span style={{ color: "red", fontWeight: "700" }}>
                            X
                          </span>
                        )}
                      </td>

                      <td>
                        <button
                          className="delete-btn"
                          onClick={() => handleDelete(loan.id)}
                        >
                          Delete
                        </button>
                      </td>
                    </tr>
                  );
                })
              )}
            </tbody>
          </table>
        </div>
      </section>

      {/* ================= PAGINATION ================= */}
      {totalPages > 1 && loans.length > 0 && (
        <div className="loan-report-pagination">
          <button
            onClick={() => {
              const newPage = currentPage - 1;
              setCurrentPage(newPage);
              fetchLoans(newPage, rowsPerPage);
            }}
            disabled={currentPage === 1}
          >
            ⬅ Prev
          </button>

          <span>
            Page {currentPage} of {totalPages}
          </span>

          <button
            onClick={() => {
              const newPage = currentPage + 1;
              setCurrentPage(newPage);
              fetchLoans(newPage, rowsPerPage);
            }}
            disabled={currentPage === totalPages}
          >
            Next ➡
          </button>
        </div>
      )}

      <ToastContainer position="top-right" autoClose={3000} />
    </div>
  );
};

export default LoanReportTest;
